import { render, staticRenderFns } from "./UserControlBox.vue?vue&type=template&id=3bf3e06b&scoped=true"
import script from "./UserControlBox.vue?vue&type=script&lang=js"
export * from "./UserControlBox.vue?vue&type=script&lang=js"
import style0 from "./UserControlBox.vue?vue&type=style&index=0&id=3bf3e06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf3e06b",
  null
  
)

export default component.exports